import '../Components/_Base.js';
import '../Components/_Anchor.js';
import '../Components/_Slider.js';
import '../Components/_Accordion.js';
import '../Components/_Header.js';
